import { useRef, useState } from 'react';
import { Button, Paragraph, Text } from '@hungryroot/ramen';

import styles from './PromoCodeInput.module.css';

interface Props {
  label: string;
  error?: string;
  initialValue?: string;
  placeholder: string;
  actionText: string;
  onSubmit(value: string): void;
  onCancel(): void;
  autofocus?: boolean;
  loading?: boolean;
}

export function PromoCodeInput({
  initialValue = '',
  error,
  label,
  loading,
  onSubmit,
  onCancel,
  autofocus = true,
  placeholder,
  actionText,
}: Props) {
  const wrapperClassName = error !== undefined ? styles.error : styles.wrapper;
  const [inputValue, setInputValue] = useState<string>(initialValue);
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={wrapperClassName}>
      <div
        tabIndex={0}
        onKeyUp={(e) => {
          if (e.key === 'Escape') {
            onCancel();
          }

          if (e.key === 'Enter' && inputValue) {
            onSubmit(inputValue);
          }
        }}
        ref={containerRef}
        onBlur={(e) => {
          if (containerRef.current === null) {
            return;
          }
          if (containerRef.current.contains(e.relatedTarget) === false) {
            onCancel();
          }
        }}
        className={styles.container}
      >
        <label className={styles['label-wrapper']}>
          <Paragraph variant="caption" className={styles.label}>
            {label}
          </Paragraph>
          <Text className={styles['input-wrapper']}>
            <input
              autoFocus={autofocus}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              placeholder={placeholder}
              type="text"
              className={styles.input}
            />
          </Text>
        </label>
        <Button
          onClick={() => {
            if (inputValue === undefined) {
              return;
            }

            onSubmit(inputValue);
          }}
          size="small"
          loading={loading}
          style="default"
          prominence="tertiary"
          textPrimary={loading === true ? 'Saving' : actionText}
        />
      </div>
      {error !== undefined && (
        <Paragraph variant="caption" className={styles['error-text']}>
          {error}
        </Paragraph>
      )}
    </div>
  );
}
